import { render, staticRenderFns } from "./modal-link-receipts.vue?vue&type=template&id=58c825fd&scoped=true"
import script from "./modal-link-receipts.vue?vue&type=script&lang=js"
export * from "./modal-link-receipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c825fd",
  null
  
)

export default component.exports